/**
 * 集合页 - 商品网格：触底自动加载下一页（Section Rendering API）
 * 仅作用于本 section 根节点内；支持主题编辑器 section 重载。
 */
(() => {
  if (window.__ncProductsScrollLoaded) return;
  window.__ncProductsScrollLoaded = true;

  const init = (root) => {
    const grid = root.querySelector('[data-nc-grid]');
    const sentinel = root.querySelector('[data-nc-more]');
    if (!grid || !sentinel || sentinel.dataset.ncReady) return;
    sentinel.dataset.ncReady = 'true';

    let loading = false;

    const loadNext = async (manual) => {
      if (loading) return;
      const url = sentinel.dataset.nextUrl;
      if (!url) return;
      // 自动触发时跳过已失败状态（仅允许手动点击重试），避免网络异常时无限请求
      if (!manual && sentinel.dataset.ncFailed) return;
      loading = true;
      sentinel.classList.remove('is-error');
      sentinel.classList.add('is-loading');
      try {
        const separator = url.includes('?') ? '&' : '?';
        const response = await fetch(`${url}${separator}section_id=${root.dataset.sectionId}`, {
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextRoot = doc.getElementById(root.id);
        if (!nextRoot) throw new Error('section not rendered');
        nextRoot.querySelectorAll('[data-nc-grid] > li').forEach((li) => {
          grid.appendChild(document.adoptNode(li));
        });
        const nextSentinel = nextRoot.querySelector('[data-nc-more]');
        if (nextSentinel && nextSentinel.dataset.nextUrl) {
          sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
        } else {
          observer.disconnect();
          sentinel.remove();
        }
      } catch (error) {
        sentinel.dataset.ncFailed = 'true';
        sentinel.classList.add('is-error');
        console.warn('[nc-products] failed to load next page:', error);
      } finally {
        loading = false;
        sentinel.classList.remove('is-loading');
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) loadNext(false);
        });
      },
      // 移动端滑动速度快，加大提前预加载距离
      { rootMargin: matchMedia('(max-width: 989px)').matches ? '800px 0px' : '400px 0px' }
    );

    root.querySelector('[data-nc-retry]').addEventListener('click', () => loadNext(true));
    observer.observe(sentinel);

    const onUnload = (event) => {
      if (event.target && (event.target === root || event.target.contains(root))) {
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    };
    document.addEventListener('shopify:section:unload', onUnload);
  };

  /**
   * AJAX 加购：拦截原生表单提交，调用主题购物车抽屉的 add()（成功后自动打开侧边栏）。
   * cart-container 不可用时保留原生提交兜底。
   */
  const initAddToCart = (root) => {
    root.querySelectorAll('.nc-card__atc-form').forEach((form) => {
      if (form.dataset.ncAtcReady) return;
      form.dataset.ncAtcReady = 'true';
      form.addEventListener('submit', async (event) => {
        const cartContainer = document.querySelector('cart-container');
        if (!cartContainer || typeof cartContainer.add !== 'function') return;
        event.preventDefault();
        const button = form.querySelector('.nc-card__atc');
        button.disabled = true;
        try {
          await cartContainer.add(new FormData(form));
        } catch (error) {
          alert(error.message);
        } finally {
          button.disabled = false;
        }
      });
    });
  };

  const boot = (scope) =>
    (scope || document).querySelectorAll('[data-nc-products]').forEach((root) => {
      init(root);
      initAddToCart(root);
    });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
